import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';

import {PopoverModule} from 'ngx-popover';

import {CollapseMenuComponent} from './collapse-menu/collapse-menu.component';
import {RecentProjectsComponent} from './recent-projects/recent-projects.component';
import {FullScreenComponent} from './full-screen/full-screen.component';

import {ActivitiesComponent} from './activities/activities.component';
import {ActivitiesMessageComponent} from './activities/activities-message/activities-message.component';
import {ActivitiesNotificationComponent} from './activities/activities-notification/activities-notification.component';
import {ActivitiesTaskComponent} from './activities/activities-task/activities-task.component';
import {HeaderComponent} from './header.component';

// import {LayoutSwitcherComponent} from '../layout-switcher.component'; //2018-03-05   李红强   注释 
import {RibbonComponent} from '../ribbon/ribbon.component';
import { RouteBreadcrumbsComponent } from '../ribbon/route-breadcrumbs.component';
import {TooltipModule, BsDropdownModule} from 'ngx-bootstrap';

import {UtilsModule} from '../../utils/utils.module';
import {SpeechButtonComponent} from './speech-button/speech-button.component';
import {I18nModule} from '../../i18n/i18n.module';
import {PsI18nModule} from '../../../pf.core/i18n/psi18n.module';
import {UserModule} from '../../user/user.module';
import {VoiceControlModule} from '../../voice-control/voice-control.module';

import {ConfirmDialogModule} from 'primeng/primeng';
import {BlockUIModule} from 'primeng/primeng';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,

    VoiceControlModule,

    TooltipModule,
    BsDropdownModule,

    PsI18nModule,
    UtilsModule, I18nModule, UserModule, PopoverModule,
    ConfirmDialogModule,
    BlockUIModule
  ],
  declarations: [
    ActivitiesMessageComponent,
    ActivitiesNotificationComponent,
    ActivitiesTaskComponent,
    RecentProjectsComponent,
    FullScreenComponent,
    CollapseMenuComponent,
    ActivitiesComponent,
    HeaderComponent,
    SpeechButtonComponent,
    RibbonComponent,
    // LayoutSwitcherComponent,//2018-03-05   李红强   注释 
    RouteBreadcrumbsComponent,
  ],
  exports: [
    HeaderComponent,
    RibbonComponent,
    // LayoutSwitcherComponent,//2018-03-05   李红强   注释 
  ]
})
export class HeaderModule {}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/header.module.ts